import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VOverlay,{attrs:{"value":_vm.loading,"z-index":"1000"}},[_c('div',{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"64"}}),(_vm.message)?_c('div',{staticClass:"white--text mt-4 text-subtitle-1"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }